export let datacenter_ibm = [
    {code: 'ams01', country: 'nl', name: 'ams01'},
    {code: 'ams03', country: 'nl', name: 'ams03'},
    {code: 'che01', country: 'ind', name: 'che01'},
    {code: 'dal01', country: 'us', name: 'dal01'},
    {code: 'dal05', country: 'us', name: 'dal05'},
    {code: 'dal06', country: 'us', name: 'dal06'},
    {code: 'dal09', country: 'us', name: 'dal09'},
    {code: 'dal10', country: 'us', name: 'dal10'},
    {code: 'dal12', country: 'us', name: 'dal12'},
    {code: 'dal13', country: 'us', name: 'dal13'},
    {code: 'sjc01', country: 'us', name: 'sjc01'},
    {code: 'sjc03', country: 'us', name: 'sjc03'},
    {code: 'sjc04', country: 'us', name: 'sjc04'},
    {code: 'hou02', country: 'us', name: 'hou02'},
    {code: 'wdc01', country: 'us', name: 'wdc01'},
    {code: 'wdc04', country: 'us', name: 'wdc04'},
    {code: 'wdc06', country: 'us', name: 'wdc06'},
    {code: 'wdc07', country: 'us', name: 'wdc07'},
    {code: 'fra02', country: 'de', name: 'fra02'},
    {code: 'fra04', country: 'de', name: 'fra04'},
    {code: 'fra05', country: 'de', name: 'fra05'},
    {code: 'sng01', country: 'sg', name: 'sng01'},
    {code: 'hkg02', country: 'ch', name: 'hkg02'},
    {code: 'lon02', country: 'uk', name: 'lon02'},
    {code: 'lon04', country: 'uk', name: 'lon04'},
    {code: 'lon06', country: 'uk', name: 'lon06'},
    {code: 'lon05', country: 'uk', name: 'lon05'},
    {code: 'mel01', country: 'au', name: 'mel01'},
    {code: 'mex01', country: 'mex', name: 'mex01'},
    {code: 'mil01', country: 'ita', name: 'mil01'},
    {code: 'mon01', country: 'ca', name: 'mon01'},
    {code: 'osl01', country: 'nor', name: 'osl01'},
    {code: 'par01', country: 'fr', name: 'par01'},
    {code: 'sao01', country: 'bra', name: 'sao01'},
    {code: 'sea01', country: 'us', name: 'sea01'},
    {code: 'seo01', country: 'kor', name: 'seo01'},
    {code: 'syd01', country: 'au', name: 'syd01'},
    {code: 'syd04', country: 'au', name: 'syd04'},
    {code: 'syd05', country: 'au', name: 'syd05'},
    {code: 'tok02', country: 'jp', name: 'tok02'},
    {code: 'tok04', country: 'jp', name: 'tok04'},
    {code: 'tok05', country: 'jp', name: 'tok05'},
    {code: 'tor01', country: 'ca', name: 'tor01'}
];

export let datacenter_aws = [
    {code: 'us-east-1', country: 'us', name: 'US East (N. Virginia)'},
    {code: 'us-east-2', country: 'us', name: 'US East (Ohio)'},
    {code: 'us-west-1', country: 'us', name: 'US West (N. California)'},
    {code: 'us-west-2', country: 'us', name: 'US West (Oregon)'},
    {code: 'ca-central-1', country: 'ca', name: 'Canada (Central)'},
    {code: 'eu-central-1', country: 'de', name: 'EU (Frankfurt)'},
    {code: 'eu-west-1', country: 'irl', name: 'EU (Ireland)'},
    {code: 'eu-west-2', country: 'uk', name: 'EU (London)'},
    {code: 'eu-west-3', country: 'fr', name: 'EU (Paris)'},
    {code: 'ap-northeast-1', country: 'jp', name: 'Asia Pacific (Tokyo)'},
    {code: 'ap-northeast-2', country: 'kor', name: 'Asia Pacific (Seoul)'},
    {code: 'ap-northeast-3', country: 'jp', name: 'Asia Pacific (Osaka-Local)'},
    {code: 'ap-southeast-1', country: 'sg', name: 'Asia Pacific (Singapore)'},
    {code: 'ap-southeast-2', country: 'au', name: 'Asia Pacific (Sydney)'},
    {code: 'ap-south-1', country: 'ind', name: 'Asia Pacific (Mumbai)'},
    {code: 'sa-east-1', country: 'bra', name: 'South America (São Paulo)'}
];

export let datacenter_gc = [
    {code: 'asia-east1', country: 'twn', name: 'Changhua County, Taiwan'},
    {code: 'asia-northeast1', country: 'jp', name: 'Tokyo, Japan'},
    {code: 'asia-south1', country: 'ind', name: 'Mumbai, India'},
    {code: 'asia-southeast1', country: 'sg', name: 'Jurong West, Singapore'},
    {code: 'australia-southeast1', country: 'au', name: 'Sydney, Australia'},
    {code: 'europe-north1', country: 'fin', name: 'Hamina, Finland'},
    {code: 'europe-west1', country: 'be', name: 'St. Ghislain, Belgium'},
    {code: 'europe-west2', country: 'uk', name: 'London, England, UK'},
    {code: 'europe-west3', country: 'de', name: 'Frankfurt, Germany'},
    {code: 'europe-west4', country: 'nl', name: 'Eemshaven, Netherlands'},
    {code: 'northamerica-northeast1', country: 'ca', name: 'Montreal, Quebec, Canada'},
    {code: 'southamerica-east1', country: 'bra', name: 'São Paulo, Brazil'},
    {code: 'us-central1', country: 'us', name: 'Council Bluffs, Iowa, USA'},
    {code: 'us-east1', country: 'us', name: 'Moncks Corner, South Carolina, USA'},
    {code: 'us-east4', country: 'us', name: 'Ashburn, Northern Virgina, USA'},
    {code: 'us-west1', country: 'us', name: 'The Dalles, Oregon, USA'},
    {code: 'us-west2', country: 'us', name: 'Los Angeles, California, USA'}
];

export let datacenter_azu = [
    {code: 'eastasia', country: 'ind', name: 'East Asia'},
    {code: 'southeastasia', country: 'ind', name: 'Southeast Asia'},
    {code: 'centralus', country: 'us', name: 'Central US'},
    {code: 'eastus', country: 'us', name: 'East US'},
    {code: 'eastus2', country: 'us', name: 'East US 2'},
    {code: 'westus', country: 'us', name: 'West US'},
    {code: 'northcentralus', country: 'us', name: 'North Central US'},
    {code: 'southcentralus', country: 'us', name: 'South Central US'},
    {code: 'northeurope', country: 'eu', name: 'North Europe'},
    {code: 'westeurope', country: 'eu', name: 'West Europe'},
    {code: 'japanwest', country: 'jp', name: 'Japan West'},
    {code: 'japaneast', country: 'jp', name: 'Japan East'},
    {code: 'brazilsouth', country: 'bra', name: 'Brazil South'},
    {code: 'australiaeast', country: 'au', name: 'Australia East'},
    {code: 'australiasoutheast', country: 'au', name: 'Australia Southeast'},
    {code: 'southindia', country: 'ind', name: 'South India'},
    {code: 'centralindia', country: 'ind', name: 'Central India'},
    {code: 'westindia', country: 'ind', name: 'West India'},
    {code: 'canadacentral', country: 'ca', name: 'Canada Central'},
    {code: 'canadaeast', country: 'ca', name: 'Canada East'},
    {code: 'uksouth', country: 'uk', name: 'UK South'},
    {code: 'ukwest', country: 'uk', name: 'UK West'},
    {code: 'westcentralus', country: 'us', name: 'West Central US'},
    {code: 'westus2', country: 'us', name: 'West US 2'},
    {code: 'koreacentral', country: 'kor', name: 'Korea Central'},
    {code: 'koreasouth', country: 'kor', name: 'Korea South'},
    {code: 'francecentral', country: 'fr', name: 'France Central'},
    {code: 'francesouth', country: 'fr', name: 'France South'},
    {code: 'australiacentral', country: 'au', name: 'Australia Central'},
    {code: 'australiacentral2', country: 'au', name: 'Australia Central 2'},
    {code: 'southafricawest', country: 'sa', name: 'South Africa West'},
    {code: 'southafricanorth', country: 'sa', name: 'South Africa North'},
    {code: 'uaecentral', country: 'ae', name: 'UAE Central'},
    {code: 'uaenorth', country: 'ae', name: 'UAE North'},
    {code: 'germanywestcentral', country: 'de', name: 'Germany West Central'},
    {code: 'germanynorth', country: 'de', name: 'Germany North'},
    {code: 'switzerlandnorth', country: 'sw', name: 'Switzerland North'},
    {code: 'switzerlandwest', country: 'sw', name: 'Switzerland West'},
    {code: 'norwaywest', country: 'nor', name: 'Norway West'},
    {code: 'norwayeast', country: 'nor', name: 'Norway East'}
];

export let datacenter_upc = [
    {code: 'de-fra1', country: 'de', name: 'Frankfurt #1'},
    {code: 'fi-hel1', country: 'fin', name: 'Helsinki #1'},
    {code: 'fi-hel2', country: 'fin', name: 'Helsinki #2'},
    {code: 'nl-ams1', country: 'nl', name: 'Amsterdam #1'},
    {code: 'sg-sin1', country: 'sg', name: 'Singapore #1'},
    {code: 'uk-lon1', country: 'uk', name: 'London #1'},
    {code: 'us-chi1', country: 'us', name: 'Chicago #1'},
    {code: 'us-sjo1', country: 'us', name: 'San Jose #1'},
    {code: 'es-mad1', country: 'esp', name: 'Madrid #1'},
    {code: 'us-nyc1', country: 'us', name: 'New York #1'},
    {code: 'pl-waw1', country: 'pol', name: 'Warsaw #1'},
    {code: 'au-syd1', country: 'au', name: 'Sydney #1'}
];

export let datacenter_htz = [
    {code: 'fsn1', country: 'de', name: 'Falkenstein'},
    {code: 'nbg1', country: 'de', name: 'Nuremberg'},
    {code: 'hel1', country: 'fin', name: 'Helsinki'},
    {code: 'ash', country: 'us', name: 'Ashburn'},
    {code: 'hil', country: 'us', name: 'Hillsboro'},
];

export let datacenter_ali = [
    {code: 'cn-hangzhou', country: 'ch', name: 'China East 1 (Hangzhou)'},
    {code: 'cn-shanghai', country: 'ch', name: 'China East 2 (Shanghai)'},
    {code: 'cn-qingdao', country: 'ch', name: 'China North 1 (Qingdao)'},
    {code: 'cn-beijing', country: 'ch', name: 'China North 2 (Beijing)'},
    {code: 'cn-zhangjiakou', country: 'ch', name: 'China North 3 (Zhangjiakou)'},
    {code: 'cn-huhehaote', country: 'ch', name: 'China North 5 (Hohhot)'},
    {code: 'cn-shenzhen', country: 'ch', name: 'China South 1 (Shenzhen)'},
    {code: 'cn-hongkong', country: 'ch', name: 'Hong Kong'},
    {code: 'us-east-1', country: 'us', name: 'US East 1 (Virginia)'},
    {code: 'ap-southeast-1', country: 'sg', name: 'Asia Pacific SE 1 (Singapore)'},
    {code: 'ap-southeast-2', country: 'au', name: 'Asia Pacific SE 2 (Sydney)'},
    {code: 'ap-southeast-3', country: 'my', name: 'Asia Pacific SE 3 (Kuala Lumpur)'},
    {code: 'ap-southeast-5', country: 'id', name: 'Asia Pacific SE 5 (Jakarta)'},
    {code: 'ap-northeast-1', country: 'jp', name: 'Asia Pacific NE 1 (Tokyo)'},
    {code: 'ap-south-1', country: 'ind', name: 'Asia Pacific SOU 1 (Mumbai)'},
    {code: 'eu-central-1', country: 'de', name: 'EU Central 1 (Frankfurt)'},
    {code: 'eu-west-1', country: 'uk', name: 'UK (London)'},
    {code: 'me-east-1', country: 'ae', name: 'Middle East 1 (Dubai)'}
];